/*
 * fn: buildCardId
 *
 * Builds a unique card ID from slug, set and collectorNumber
 *
 */
import { CARD_ID_DELIMITER, type CardIdType } from '@/defs/card'

type Props = {
  collectorNumber?: string
  set?: string
  slug: string
}

export const buildCardId = ({ collectorNumber, set, slug }: Props): CardIdType =>
  !set ? (slug as CardIdType) : ([slug, set, collectorNumber || ''].join(CARD_ID_DELIMITER) as CardIdType)
